import styled from 'styled-components';
import { Card } from '@/ui/primatives';

export const FileCard = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
